import { identity } from 'lodash';
function createAction(type, payloadCreator = identity, metaCreator) {
    function actionCreator(...args) {
        const payload = args[0] instanceof Error ? args[0] : payloadCreator?.apply(undefined, args);
        const action = {
            type,
        };
        if (payload != null) {
            action.payload = payload;
        }
        // Handle FSA errors where the payload is an Error object. Set error.
        if (args instanceof Error || payload instanceof Error) {
            action.error = true;
        }
        if (metaCreator) {
            action.meta = metaCreator.apply(undefined, args);
        }
        return action;
    }
    actionCreator.toString = () => type;
    actionCreator.type = type;
    return actionCreator;
}
export default createAction;
//# sourceMappingURL=create-action.js.map